window.app_models.hotel_placement = {
    id:null,
    check_in_date:null,
    check_out_date:null,
    invoice_requests:[window.app_models.invoice_request],
    iata:0,
    iata_no:null,
    iata_notes:null,
    bed_configuration:null,
    price:null,
    completed:null,
    completed_date:null,
    secured_through:null,
    placement_id:null,
    hotel_id:null,
    card_id:null,
    virtual_card_id:null,
    room_type_id:null,
    pet_fee: null,
    parking_fee: null,
    kitchen_details: null,
    confirmation_no: null,
    rooms: [window.app_models.room],
    hotel: window.app_models.hotel,
    original_hotel: window.app_models.hotel,
};



// WEBPACK FOOTER //
// ./resources/assets/js/models/hotel_placement.js